/* BRANDSETS (v41) – hero slider (sections/bs-hero.liquid)
   - slajdy w poziomym torze ze scroll-snap (palec na telefonie, strzałki i kreski na komputerze),
   - autoodtwarzanie co N s, pauza po najechaniu, przy fokusie, przy otwartej karcie i w ukrytej karcie przeglądarki,
   - kropka = X/Y w % CAŁEGO zdjęcia; tu liczymy, gdzie ten punkt wypada po przycięciu (object-fit: cover),
   - karta produktu: „+” dodaje od razu (1 wariant) albo pokazuje rozmiary; po dodaniu otwiera się koszyk boczny. */
(function () {
  if (customElements.get('bs-hero')) return;

  var MQ = window.matchMedia('(max-width: 989px)');
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  function pct(v, box, size) {
    v = String(v || '50%').trim();
    if (v === 'left' || v === 'top') return 0;
    if (v === 'right' || v === 'bottom') return box - size;
    if (v === 'center') return (box - size) / 2;
    if (v.slice(-1) === '%') return (box - size) * parseFloat(v) / 100;
    return parseFloat(v) || 0;
  }

  class BsHero extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.track = this.querySelector('[data-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.bs-hero__slide'));
      this.bars = Array.prototype.slice.call(this.querySelectorAll('[data-go]'));
      this.index = 0;
      this.delay = (parseInt(this.dataset.autoplay, 10) || 0) * 1000;
      this.hover = false;
      this.focus = false;
      this.openCard = null;

      var self = this;
      this.onScroll = function () {
        if (self._raf) return;
        self._raf = requestAnimationFrame(function () {
          self._raf = null;
          var w = self.track.clientWidth || 1;
          var i = Math.round(self.track.scrollLeft / w);
          /* przewijanie z kodu (strzałki, autoodtwarzanie) mija po drodze inne slajdy - ignorujemy je */
          if (self._target != null) { if (i === self._target) self._target = null; return; }
          if (i !== self.index) self.setActive(i);
        });
      };
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      var prev = this.querySelector('[data-prev]');
      var next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.index - 1, true); });
      if (next) next.addEventListener('click', function () { self.go(self.index + 1, true); });
      this.bars.forEach(function (b) {
        b.addEventListener('click', function () { self.go(parseInt(b.dataset.go, 10), true); });
      });

      this.addEventListener('mouseenter', function () { self.hover = true; self.updatePlay(); });
      this.addEventListener('mouseleave', function () { self.hover = false; self.updatePlay(); });
      this.addEventListener('focusin', function () { self.focus = true; self.updatePlay(); });
      this.addEventListener('focusout', function (e) {
        if (!self.contains(e.relatedTarget)) { self.focus = false; self.updatePlay(); }
      });
      this.track.addEventListener('pointerdown', function () { self.userTouched = true; }, { passive: true });
      document.addEventListener('visibilitychange', function () { self.updatePlay(); });

      this.initHotspots();

      this.ro = new ResizeObserver(function () { self.placeAll(); });
      this.ro.observe(this);
      MQ.addEventListener ? MQ.addEventListener('change', function () { self.placeAll(); }) : MQ.addListener(function () { self.placeAll(); });

      this.setActive(0, true);

      /* edytor motywu: zaznaczenie bloku przewija do jego slajdu */
      this._onBlockSelect = function (e) {
        var s = e.target && e.target.closest && e.target.closest('.bs-hero__slide');
        if (s && self.contains(s)) {
          self.editing = true;
          self.go(parseInt(s.dataset.index, 10), false);
        }
      };
      this._onBlockDeselect = function () { self.editing = false; self.updatePlay(); };
      document.addEventListener('shopify:block:select', this._onBlockSelect);
      document.addEventListener('shopify:block:deselect', this._onBlockDeselect);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.ro) this.ro.disconnect();
      document.removeEventListener('shopify:block:select', this._onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this._onBlockDeselect);
      if (this._onDoc) document.removeEventListener('click', this._onDoc);
      if (this._onKey) document.removeEventListener('keydown', this._onKey);
    }

    go(i, user) {
      var n = this.slides.length;
      if (!n) return;
      i = ((i % n) + n) % n;
      if (user) this.userTouched = true;
      this.closeCard();
      var self = this;
      this._target = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1)) === i ? null : i;
      clearTimeout(this._tt);
      this._tt = setTimeout(function () { self._target = null; }, 1500);
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: REDUCE.matches ? 'auto' : 'smooth' });
      this.setActive(i);
    }

    setActive(i, first) {
      this.index = i;
      var self = this;
      this.slides.forEach(function (s, k) {
        if (k === i) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      });
      var cur = this.slides[i];
      this.dataset.controls = (cur && cur.dataset.controls) || 'dark';
      this.bars.forEach(function (b, k) {
        var on = k === i;
        b.classList.toggle('is-active', on);
        if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
        /* restart animacji kreski */
        var fill = b.querySelector('i');
        if (on && fill) { fill.style.animation = 'none'; void fill.offsetWidth; fill.style.animation = ''; }
      });
      if (!first) this.closeCard();
      this.schedule();
      if (first) this.placeAll();
    }

    canPlay() {
      return this.delay > 0 && this.slides.length > 1 && !REDUCE.matches && !this.hover && !this.focus &&
        !this.openCard && !this.editing && !document.hidden;
    }

    updatePlay() {
      this.classList.toggle('is-paused', !this.canPlay());
      if (this.canPlay()) this.schedule(); else clearTimeout(this.timer);
    }

    schedule() {
      clearTimeout(this.timer);
      var auto = this.delay > 0 && this.slides.length > 1 && !REDUCE.matches;
      this.classList.toggle('is-autoplay', auto);
      this.classList.toggle('is-paused', auto && !this.canPlay());
      if (!this.canPlay()) return;
      var self = this;
      this.timer = setTimeout(function () { self.go(self.index + 1, false); }, this.delay);
    }

    /* ---------- kropki ---------- */
    initHotspots() {
      var self = this;
      this.slides.forEach(function (slide) {
        var hs = slide.querySelector('[data-hs]');
        if (!hs) return;
        var card = slide.querySelector('[data-card]');
        var img = slide.querySelector('.bs-hero__img');
        if (img && img.tagName === 'IMG' && !img.complete) {
          img.addEventListener('load', function () { self.place(slide); }, { once: true });
        }
        hs.addEventListener('click', function (e) {
          e.stopPropagation();
          if (self.openCard === card) self.closeCard(); else self.showCard(slide);
        });
        var add = card.querySelector('[data-add]');
        var sizes = card.querySelector('[data-sizes]');
        add.addEventListener('click', function (e) {
          e.stopPropagation();
          if (add.dataset.variantId) { self.addToCart(add.dataset.variantId, add, add, card); return; }
          if (sizes) {
            sizes.hidden = !sizes.hidden;
            self.positionCard(slide);
            if (!sizes.hidden && e.detail === 0) {
              var f = sizes.querySelector('.bs-hero__size');
              if (f) f.focus({ preventScroll: true });
            }
          }
        });
        if (sizes) {
          sizes.addEventListener('click', function (e) {
            var b = e.target.closest('[data-size]');
            if (!b) return;
            e.stopPropagation();
            self.addToCart(b.dataset.size, b, add, card);
          });
        }
        card.addEventListener('click', function (e) { e.stopPropagation(); });
      });

      this._onDoc = function () { self.closeCard(); };
      this._onKey = function (e) {
        if (e.key === 'Escape' && self.openCard) {
          var hs = self.openCard.parentNode.querySelector('[data-hs]');
          self.closeCard();
          if (hs) hs.focus({ preventScroll: true });
        }
      };
      document.addEventListener('click', this._onDoc);
      document.addEventListener('keydown', this._onKey);
    }

    placeAll() {
      var self = this;
      this.slides.forEach(function (s) { self.place(s); });
      if (this.openCard) this.positionCard(this.openCard.parentNode);
    }

    place(slide) {
      var hs = slide.querySelector('[data-hs]');
      var img = slide.querySelector('.bs-hero__img');
      if (!hs || !img || img.tagName !== 'IMG' || !img.naturalWidth) return;
      var sr = slide.getBoundingClientRect();
      var ir = img.getBoundingClientRect();
      if (!ir.width || !ir.height) return;
      var nw = img.naturalWidth, nh = img.naturalHeight;
      var s = Math.max(ir.width / nw, ir.height / nh);
      var rw = nw * s, rh = nh * s;
      var pos = (getComputedStyle(img).objectPosition || '50% 50%').split(/\s+/);
      var ox = pct(pos[0], ir.width, rw);
      var oy = pct(pos[1] || '50%', ir.height, rh);
      var mob = MQ.matches;
      var px = parseFloat(mob ? hs.dataset.mx : hs.dataset.x) / 100;
      var py = parseFloat(mob ? hs.dataset.my : hs.dataset.y) / 100;
      var x = ir.left - sr.left + ox + px * rw;
      var y = ir.top - sr.top + oy + py * rh;
      var inside = x > ir.left - sr.left + 16 && x < ir.right - sr.left - 16 && y > ir.top - sr.top + 16 && y < ir.bottom - sr.top - 16;
      hs.style.setProperty('--hx', Math.round(x) + 'px');
      hs.style.setProperty('--hy', Math.round(y) + 'px');
      hs.classList.toggle('is-placed', inside);
      hs._x = x;
      hs._y = y;
    }

    showCard(slide) {
      this.closeCard();
      var hs = slide.querySelector('[data-hs]');
      var card = slide.querySelector('[data-card]');
      if (!hs || !card) return;
      card.hidden = false;
      hs.setAttribute('aria-expanded', 'true');
      this.openCard = card;
      this.positionCard(slide);
      this.updatePlay();
    }

    closeCard() {
      if (!this.openCard) return;
      var card = this.openCard;
      var slide = card.parentNode;
      var hs = slide.querySelector('[data-hs]');
      var sizes = card.querySelector('[data-sizes]');
      card.hidden = true;
      if (sizes) sizes.hidden = true;
      if (hs) hs.setAttribute('aria-expanded', 'false');
      this.openCard = null;
      this.updatePlay();
    }

    positionCard(slide) {
      var hs = slide.querySelector('[data-hs]');
      var card = slide.querySelector('[data-card]');
      if (!hs || !card || card.hidden) return;
      var W = slide.clientWidth, H = slide.clientHeight;
      var cw = card.offsetWidth, ch = card.offsetHeight;
      var x, y;
      if (MQ.matches) {
        /* telefon: karta na całą szerokość, przy dolnej albo górnej krawędzi - tak, żeby nie zasłaniała kropki */
        card.style.left = '12px';
        card.style.right = '12px';
        cw = card.offsetWidth;
        ch = card.offsetHeight;
        x = 0;
        /* w układzie „zdjęcie + panel” karta zostaje na zdjęciu, żeby nie zasłaniać tekstu */
        var media = slide.querySelector('.bs-hero__media');
        var top = 0, bottom = H;
        if (slide.classList.contains('bs-hero__slide--m-stacked') && media) bottom = media.offsetHeight;
        if (hs._y - top > ch + 40) y = top + 12;
        else if (bottom - hs._y > ch + 40) y = bottom - ch - 12;
        else y = hs._y > H / 2 ? 12 : H - ch - 12;
      } else {
        card.style.left = '';
        card.style.right = '';
        x = hs._x + 34;
        if (x + cw > W - 16) x = hs._x - 34 - cw;
        x = Math.max(16, x);
        y = Math.min(Math.max(16, hs._y - ch / 2), H - ch - 16);
      }
      card.style.setProperty('--cx', Math.round(x) + 'px');
      card.style.setProperty('--cy', Math.round(y) + 'px');
    }

    /* ---------- koszyk ---------- */
    addToCart(id, busyEl, addBtn, card) {
      var self = this;
      var msg = card.querySelector('[data-msg]');
      if (msg) msg.hidden = true;
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var fd = new FormData();
      fd.append('id', id);
      fd.append('quantity', '1');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.section; }));
        fd.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(addBtn);
      }
      busyEl.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if ((res.status && res.status !== 200) || res.errors) throw new Error(res.description || res.message || res.errors);
          addBtn.classList.add('is-added');
          setTimeout(function () { addBtn.classList.remove('is-added'); }, 1800);
          self.closeCard();
          if (cart && typeof cart.renderContents === 'function') cart.renderContents(res);
          else window.location.href = '/cart';
          if (typeof window.updateCartCounters === 'function') window.updateCartCounters();
          if (typeof window.updateFreeShipping === 'function') window.updateFreeShipping();
        })
        .catch(function (err) {
          console.error('[bs-hero]', err);
          if (msg) { msg.hidden = false; self.positionCard(card.parentNode); }
        })
        .finally(function () { busyEl.classList.remove('is-loading'); });
    }
  }

  customElements.define('bs-hero', BsHero);
})();
